@if (isOffline()) {
  <mat-icon class="banner-icon">wifi_off</mat-icon>

  <p class="banner-text mat-body-medium">
    <span class="banner-reason">Keine Internetverbindung.</span>
    <span class="banner-hint">Änderungen werden gerade nicht gespeichert.</span>
  </p>

  @let _seconds = connectionService.secondsUntilRetry();
  @if (_seconds !== null && _seconds > 0) {
    <span class="banner-countdown mat-body-small">Nächster Versuch in {{ _seconds }} s</span>
  }

  <button type="button" matButton (click)="connectionService.retryNow()">Jetzt versuchen</button>
}
